import { getPublicApiUrl, AXIOS_UNAUTHED } from './shared';

const get = (languageCode) => {
  return AXIOS_UNAUTHED.get(`${getPublicApiUrl()}/regions/${languageCode}/terms`);
};

export { get };
